import React from "react";

// Styling Files
import "../../styles.css";
import "react-awesome-button/dist/styles.css";

// Relative Imports - Components
import { InfiniteMovingCards } from "../Components/InfiniteMovingCards";
import placeholderIcon from "../../Assets/placeholder.png"; // Update with correct path

const RecognitionsSection = () => {
  const testimonials = [
    {
      image: placeholderIcon,
      websiteTitle: "Satisfied Customer",
      title: "This is my second experience with UIF in less than 3 years.",
      content: "Dealing with Brother Ali Rafiq for this Refinance was Absolutely Delightful. I hear people talking about Chasing loan Officers, But Ali was literally available anytime. He explained everything in detail, offered genuine saving options and made this Super Smooth and Quick. Fantastic. Thank you UIF for having such a professional person in your team.",
    },
    {
      image: placeholderIcon,
      websiteTitle: "Happy Client",
      title: "We choose UIF because its a prestigious organizations.",
      content: "Mr Mohsin is a cooperative person. He always ready for any help with his heartily effort everything was done in time. Its helped us to make our dream true.",
    },
    {
      image: placeholderIcon,
      websiteTitle: "First-Time Homebuyer",
      title: "UIF is the right bank to choose when getting your dream house.",
      content: "It was my first time buying home the loan officer Ahmad Maroof helped me a lot to go through all obstacles. I recommend to select UIF and brother Ahmad as a loan officer.",
    },
    {
      image: placeholderIcon,
      websiteTitle: "Grateful Customer",
      title: "We appreciate all your help and effort throughout the home buying process.",
      content: "I would certainly recommend your services. The whole process went smoothly, you answered patiently every question we had, as we were a first time buyer with a lot of questions in our minds. Thank you.",
    },
  ];

  return (
    <div className="h-[40rem] rounded-md flex flex-col antialiased bg-white items-center justify-center relative overflow-hidden">
      <h2
        style={{
          fontSize: 36,
          textAlign: "center",
          marginBottom: "20px",
          fontFamily: "'Plus Jakarta Sans', sans-serif",
        }}
      >
        Customer Testimonials
      </h2>
      <InfiniteMovingCards items={testimonials} direction="left" speed="slow" />
      <a
        href="https://www.google.com/maps/place/UIF+Corporation/@30.7036659,-141.1406297,3z/data=!3m1!5s0x8824b784115607b9:0xbe78f28e80582940!4m12!1m2!2m1!1suif+google+reviews!3m8!1s0x8824b75785bf802f:0x7f32c8ba4c15893c!8m2!3d42.5054483!4d-83.2870366!9m1!1b1!15sChJ1aWYgZ29vZ2xlIHJldmlld3MiBTgBiAEBkgEVZmluYW5jaWFsX2luc3RpdHV0aW9u4AEA!16s%2Fg%2F1thl1gws?entry=ttu&g_ep=EgoyMDI0MDkxMS4wIKXMDSoASAFQAw%3D%3D"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          marginTop: "20px",
          color: "#0066cc",
          textDecoration: "underline",
          fontFamily: "'Plus Jakarta Sans', sans-serif",
        }}
      >
        Click here to read the rest of our reviews on Google
      </a>
    </div>
  );
};

export default RecognitionsSection;
